import React, { useState } from 'react'
import { Radar, Legend, PolarRadiusAxis, PolarAngleAxis, PolarGrid, RadarChart, ResponsiveContainer } from 'recharts'
import { PALETTE } from '../../common/ThemeConstants'

export default function SkillsRadar({user, data=[]}) {
    const [opacity, setOpacity] = useState(0.5)
    return (
        <div className="cardDescription">
        {data.length > 0 ? (
            <ResponsiveContainer width={"100%"} height={250} style={{maxWidth:"100%"}}>
                <RadarChart outerRadius={90} width={730} height={250} data={data}>
                    {/* <Legend /> */}
                    <PolarGrid />
                    <PolarAngleAxis dataKey="subject" />
                    <PolarRadiusAxis angle={30} domain={[0, 150]} />
                    <Radar
                        style={{cursor:"pointer"}}
                        name={`${user.firstname} ${user.lastname}`}
                        dataKey="A"
                        stroke={PALETTE.MAINCOLOR}
                        fill={PALETTE.MAINCOLOR}
                        fillOpacity={opacity}
                        onMouseEnter={(r) => {setOpacity(0.6)}}
                        onMouseLeave={(r) => {setOpacity(0.5)}}
                    />
                </RadarChart>
            </ResponsiveContainer>
            )
            :
            <></>
        }
        </div>
    )
}